export const generativeAiAgentsStandardsSettings = "/generative_ai/agents/standards_settings";
